import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import { useToast } from "../../../contexts/ToastContext";

import ModelErrorComponent from "../../../components/modals/ModelErrorComponent";

export function CustomerDetailsViewModel(logout, customerId) {
  const { showSuccess } = useToast();
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(true);
  const [customer, setCustomer] = useState(null);
  const [customerGroupOptions, setCustomerGroupOptions] = useState(null);
  const [usersOptions, setUsersOptions] = useState(null);

  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getCustomer = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`customers/${customerId}`, payload);
    if (callResult.success) {
      setCustomer(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch customer");
    }
    setLoading(false);
  };

  const updateCustomer = async function (values) {
    let callResult = await makePutApiCall(`customers/${customer.id}`, values);

    if (callResult.success) {
      showSuccess(
        callResult.data.message || "Customer updated"
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const getCustomerGroupsForDropdown = async function () {
    setLoading(true);

    let callResult = await makePostApiCall(`getCustomersGroupsForDropdown`);
    setLoading(false);
    if (callResult.success) {
      setCustomerGroupOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const getUsersForDropdown = async function () {
    setLoading(true);

    let callResult = await makePostApiCall(`usersForDropdown`);
    setLoading(false);
    if (callResult.success) {
      setUsersOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  return {
    customerGroupOptions,
    getCustomerGroupsForDropdown,
    updateCustomer,
    getCustomer,
    slideOver,
    setSlideOver,
    customer,
    loading,
    emptyModal,
    getUsersForDropdown,
    usersOptions,
  };
}
